export const somenteNumeros = (valor) => {
    return valor.replace(/[^\d]+/g, '')
}

export const formataMoeda = (valor, casas) => {
    if (isNaN(valor) || valor === undefined) {
        valor = 0;
    }
    if(casas == undefined){
        casas = 2;
    }
    valor = parseFloat(valor)
    return valor.toLocaleString('pt-br', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
        currency: 'BRL'
    })
}

export const removeMoeda = (valor) => {
    if (valor === '' || valor === undefined || valor === null) {
        return 0
    }
    // Aceita número (ex.: quantidade preenchida por código) além da string mascarada
    if (typeof valor === 'number') {
        return valor
    }
    valor = String(valor).replaceAll('.', '')
    valor = valor.replace(',', '.')
    return parseFloat(valor)
}

export const formataTelefone = (telefone, validaNumero = true) => {
    if (validaNumero) {
        telefone = telefone.replace(/\D/g, '')
    }
    const tam = telefone.length + 1
    if (tam == 3) {
        telefone = '(' + telefone.substr(0, 3) + ')' + telefone.substr(3, tam)
    }
    if (tam == 7) {
        telefone = '(' + telefone.substr(0, 2) + ')' + telefone.substr(2, 6) + '-' + telefone.substr(6, tam)
    }
    if (tam == 11) {
        telefone = '(' + telefone.substr(0, 2) + ')' + telefone.substr(2, 4) + '-' + telefone.substr(6, tam)
    }
    if (tam == 12) {
        telefone = '(' + telefone.substr(0, 2) + ')' + telefone.substr(2, 5) + '-' + telefone.substr(7, tam)
    }
    return telefone
}

export const formataTelefoneComDDD = (telefone) => {
    let vr = telefone;
    vr = vr.replace(/[^0-9\\.]+/g, '')
    let tam = vr.length + 1
    if (tam == 3){
        telefone = '(' + vr.substr(0,3) + ')' + vr.substr(3,tam)
    } else if (tam == 7) {
        telefone = '(' + vr.substr(0, 2) + ')' + vr.substr(2,6) + '-' + vr.substr(6,tam)
    } else if (tam == 11) {
        telefone = '(' + vr.substr(0, 2) + ')' + vr.substr(2,4) + '-' + vr.substr(6,tam)
    } else if (tam == 12) {
        telefone = '(' + vr.substr(0, 2) + ')' + vr.substr(2,5) + '-' + vr.substr(7,tam)
    }
    return telefone
}

export const formataTelefoneSemDDD = (telefone) => { 
    let vr = telefone.replace(/[^0-9]+/g, '');
    const tam = vr.length;
    if(tam <= 4) {
        return vr;
    } 
    else if(tam <= 8) {
        return vr.substr(0, tam - 4) + '-' + vr.substr(tam - 4);
    } 
    else if(tam === 9) {
        return vr.substr(0, 5) + '-' + vr.substr(5, 4);
    } 
    else {
        vr = vr.substr(0, 9);
        return vr.substr(0, 5) + '-' + vr.substr(5, 4);
    }
};

export const formataTelefone0800 = (telefone) => {
    telefone = telefone.replace(/\D/g, '');
    const len = telefone.length;
    if (len <= 4) {
        return telefone;
    }
    if (len > 4 && len <= 7) {
        return telefone.substring(0, 4) + ' ' + telefone.substring(4);
    }
    const phone = telefone.substring(0, 11);
    const part1 = phone.substring(0, 4); 
    const part2 = phone.substring(4, 7); 
    const part3 = phone.substring(7); 
    return `${part1} ${part2}${part3 ? ' ' + part3 : ''}`;
};

export const formataTelefone400 = (telefone, validaNumero = true) => {
    if (validaNumero) {
        telefone = telefone.replace(/\D/g, '');
    }
    if (!telefone.startsWith('400')) {
        return telefone;
    }
    if (telefone.length <= 4) {
        return telefone;
    }
    if (telefone.length <= 8) {
        return telefone.substring(0, 4) + '-' + telefone.substring(4);
    }
    return telefone.substring(0, 8);
};

export const formataTelefoneOperadora = (telefone, validaNumero = true) => {
    if (validaNumero) {
        telefone = telefone.replace(/\D/g, '');
    }
    telefone = telefone.substring(0, 5);
    if (telefone.length <= 3) {
        return telefone;
    }
    return telefone.substring(0, 3) + '-' + telefone.substring(3);
};


export const formataCpf = (cpf) => {
    cpf = cpf.replace(/\D/g, '')
    const tam = cpf.length + 1
    if (tam > 3 && tam < 7) {
        cpf = cpf.substr(0, 3) + '.' + cpf.substr(3, tam)
    }
    if (tam >= 7 && tam < 10) {
        cpf = cpf.substr(0, 3) + '.' + cpf.substr(3, 3) + '.' + cpf.substr(6, tam - 6)
    }
    if (tam >= 10) {
        cpf = cpf.substr(0, 3) + '.' + cpf.substr(3, 3) + '.' + cpf.substr(6, 3) + '-' + cpf.substr(9, tam - 9)
    }
    return cpf
}

export const formataCnpj = (cnpj) => {
    cnpj = cnpj.replace(/[.\-/]/g, '').toUpperCase()
    const tam = cnpj.length + 1
    if (tam > 2 && tam < 6) {
        cnpj = cnpj.substr(0, 2) + '.' + cnpj.substr(2, tam)
    }
    if (tam >= 6 && tam < 9) {
        cnpj = cnpj.substr(0, 2) + '.' + cnpj.substr(2, 3) + '.' + cnpj.substr(5, tam - 5)
    }
    if (tam >= 9 && tam < 13) {
        cnpj = cnpj.substr(0, 2) + '.' + cnpj.substr(2, 3) + '.' + cnpj.substr(5, 3) + '/' + cnpj.substr(8, tam - 8)
    }
    if (tam >= 13) {
        cnpj = cnpj.substr(0, 2) + '.' + cnpj.substr(2, 3) + '.' + cnpj.substr(5, 3) + '/' + cnpj.substr(8, 4) + '-' + cnpj.substr(12, tam - 12)
    }
    return cnpj
}

export const formataCpfCnpj = (cpfCnpj) => {
    const stripped = cpfCnpj.replace(/[.\-/]/g, '').toUpperCase()
    if (stripped.length > 11 || /[A-Z]/.test(stripped)) {
        return formataCnpj(cpfCnpj)
    } else {
        return formataCpf(cpfCnpj)
    }
}

export const validaTelefone = (telefone) => {
    if (!telefone) {
        return true
    }
    telefone = telefone.replace(/[^\d]+/g, '')
    if (telefone === '') {
        return true
    }
    if (telefone.length < 10 || telefone.length > 11) {
        return false
    }
    return true
}

export const validaCep = (cep) => {
    if (!cep) {
        return true
    }
    cep = cep.replace(/[^\d]+/g, '')
    if (cep === '') {
        return true
    }
    if (cep.length !== 8) {
        return false
    }
    return true
}

export const validaCpfCnpj = (cpfCnpj) => {
    if (!cpfCnpj) {
        return true
    }
    const stripped = cpfCnpj.replace(/[.\-/]/g, '').toUpperCase()
    if (stripped === '') {
        return true
    }
    if (stripped.length > 11) {
        return validaCnpj(stripped)
    } else {
        return validaCpf(cpfCnpj)
    }
}

export const validaCpf = (cpf) => {
    if (!cpf) {
        return true
    }
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf === '') {
        return true
    }
    // Elimina CPFs invalidos conhecidos
    if (
        cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
    ) {
        return false
    }
    // Valida 1o digito
    let add = 0
    for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(9))) {
        return false
    }
    // Valida 2o digito
    add = 0
    for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i)
    }
    rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(10))) {
        return false
    }
    return true
}

export const validaCnpj = (cnpj) => {
    if (!cnpj) {
        return true
    }
    cnpj = cnpj.replace(/[.\-/]/g, '').toUpperCase()
    if (cnpj === '') {
        return true
    }
    if (cnpj.length !== 14) {
        return false
    }
    // Formato: 12 chars alfanuméricos (A-Z0-9) + 2 dígitos verificadores
    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) {
        return false
    }
    if (cnpj === '00000000000000') {
        return false
    }
    // Cálculo do DV usando valor ASCII - 48 (NT 2025.001 CNPJ Alfanumérico)
    const valorBase = '0'.charCodeAt(0) // 48
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho)
    const digitos = cnpj.substring(tamanho)
    let soma = 0
    let pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
        soma += (numeros.charCodeAt(tamanho - i) - valorBase) * pos--
        if (pos < 2) {
            pos = 9
        }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado !== parseInt(digitos.charAt(0))) {
        return false
    }
    tamanho = tamanho + 1
    numeros = cnpj.substring(0, tamanho)
    soma = 0
    pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
        soma += (numeros.charCodeAt(tamanho - i) - valorBase) * pos--
        if (pos < 2) {
            pos = 9
        }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado !== parseInt(digitos.charAt(1))) {
        return false
    }
    return true
}

export const validaEan = (ean) => {
    if (!ean) {
        return true
    }
    ean = ean.replace(/[^\d]+/g, '')
    if (ean === '') {
        return true
    }
    if (ean.length != 8 && ean.length != 12 && ean.length != 13 && ean.length != 14) {
        return false
    }
    return true
}

export const validaGtin = (valor) => {
    if (!valor) {
        return { ok: false, gtin: '', erro: 'GTIN não informado.' }
    }
    const gtin = String(valor).replace(/[^\d]+/g, '')
    if (![8, 12, 13, 14].includes(gtin.length)) {
        return { ok: false, gtin, erro: 'GTIN deve ter 8, 12, 13 ou 14 dígitos.' }
    }
    const digitos = gtin.split('').map(Number)
    const verificador = digitos.pop()
    let soma = 0
    digitos.reverse().forEach((digito, indice) => {
        soma += digito * (indice % 2 === 0 ? 3 : 1)
    })
    const calculado = (10 - (soma % 10)) % 10
    if (calculado !== verificador) {
        return { ok: false, gtin, erro: 'Dígito verificador GTIN inválido.' }
    }
    return { ok: true, gtin, erro: null }
}

export const geraCodigoEan = () => {
    let data = new Date().getTime()
    let codigo = Math.floor(Math.random() * (99999 - 1 + 1) + 1) * data + ''
    codigo = '20' + codigo.substr(-10)
    codigo += calculaDigitoEan(codigo)
    return codigo
}

function calculaDigitoEan(valor) {
    let pares = 0
    let impares = 0
    let dv
    let codigo = valor.replace('-', '')
    if (codigo.length <= 11) {
        return false
    }
    for (let i = 0; i <= 11; i++) {
        let mod = i % 2
        if (mod == 0) {
            pares += parseInt(valor[i])
        } else {
            impares += parseInt(valor[i]) * 3
        }
    }
    dv = 10 - ((impares + pares) % 10)
    if (dv > 9) {
        dv = 0
    }
    return dv
}

export const parcelaMinBoleto = (value) => {
    value = value.replaceAll('.', '')
    value = value.replace(',', '.')

    if (parseFloat(value) < 20) {
        return false
    } else {
        return true
    }
}
